import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=c06e1848&scoped=true"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
import style0 from "./Data.vue?vue&type=style&index=0&id=c06e1848&prod&lang=css"
import style1 from "./Data.vue?vue&type=style&index=1&id=c06e1848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e1848",
  null
  
)

export default component.exports